import React, { useEffect, useState,useContext } from "react";
import styled from "styled-components";
import {Link} from "react-router-dom";
import { useHistory } from "react-router-dom";
import {useLocation} from "react-router-dom";
import { useTranslation } from "react-i18next";
import config from "../data/application.properties";
import { SSOSettingsContext } from "../authentication/SSOSettings";
import { DataContext } from '../data/DataContext';
import { dlrMenuReplace } from './menuLinks';

const UL = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

const LI = styled.li`
a {
    display: flex;
    width: 100%;
    flex-direction: row;

    justify-content: center;
    color: #4c4c4c;
    font-size: 16px;
    height: 56px;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;
    text-decoration: none;
    &.active-link {
      // background-color: rgba(0,122,186,0.1);
      color: #007aba;
      font-weight: bold;
      cursor: pointer;
    }
    &.active-section {
      color: #007aba;
      font-weight: bold;
    }
    &.sub {
      padding-left: 64px;
      font-size: 14px;

      &.active {
        visibility: visible;
      }
    }
  }
  

`;

const Item = styled.div`
  display: flex;
  ${'' /* padding: 12px 18px; */}
  padding-left: ${props => `${props.dept * 18}px`};
  align-items: center;
  :hover {
    
    background-color: rgba(0, 122, 186, 0.1);
    &:active {
      color: #007aba;
    }
  }

`;
const Label = styled.span`
  width: 100%;
  display: block;
  cursor: pointer;
`;
const Arrow = styled.span`
  display: flex;
  height: 25px;
  width: 35px;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &::after {
    content: "";
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;

    border-top: 4px solid #000;

    transform: ${props => (props.toggle ? "rotate(180deg)" : "rotate(0deg)")};
  }
`;

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 24px;

  @media screen and (max-width: 750px) {
    margin: 0 15px;
    margin-bottom: 12px;
    div {
      width: 100%;
      justify-content: center;
      // margin-bottom: 12px;
      // padding-right: 16px;
    }
  }
`;
const LeftNav = styled.div`
  padding: 8px 0px;
  height: fit-content;
  min-width: 319px;
  width: fit-content;
  background-color: white;
  transition: all 0.5s;
  display: block;
  left: 0;
  overflow-x: hidden;
  z-index: 9;
  box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.25);
`;

const Divider = styled.div`
  display: flex;
  flex-direction: row;
  height: 1px;
  background-color: #979797;
  margin: 8px 14px;
`;


const MultiMenus = ({ menus }) => {
  let location = useLocation();
  const { t } = useTranslation()


  const [activeMenus, setActiveMenus] = useState(['sidebar-menu-1-0']);
  const [toggleTest, setToggleTest] = useState(true)
  const {SSOSettings} = useContext(SSOSettingsContext)
   // DLR flag
   const { dlrFeatureFlag, mlPredictionStatus } = useContext(DataContext)
/*   const handleMenuClick = (data,hasSubMenu,menuName) => {
    console.log(data,'mdv data');
    console.log(hasSubMenu,'mdv hasSubMenu')
    setToggleTest(activeMenus.includes(menuName))
  }; */

  const handleArrowClick = menuName => {
    let newActiveMenus = [...activeMenus];
    if (newActiveMenus.includes(menuName)) {
      var index = newActiveMenus.indexOf(menuName);
      if (index > -1) {
        newActiveMenus.splice(index, 1);
      }
    } else {
      newActiveMenus.push(menuName);
    }

    setActiveMenus(newActiveMenus);

  };

  const redirectToHelpDoc = () => {
    if(config.ENABLE_DOGFOOD){
      window.open(config.DOG_FOOD_DOC, "_blank");
    }else{
      window.open(config.GA_DOC, "_blank");
    }
  }

  const ListMenu = ({ dept, data, hasSubMenu, menuName, menuIndex }) => {
    
    if(dlrFeatureFlag && data.label == "menu.subMenu.automation"){
      let dlrMenu = dlrMenuReplace[data.label];
      data = dlrMenu;
      hasSubMenu = dlrMenu.submenu;
    }

    if((!dlrFeatureFlag || !mlPredictionStatus) && (data.label == "menu.subMenu.machineLearning" || data.label == "menu.subMenu.mlTimeout")){
      return null;
    }
    return (
    
      <LI>
        <Item dept={dept}>
          <Link
          onClick={(e) => {
            if(data.link === "/helpdoc"){
              redirectToHelpDoc()
              e.stopPropagation()
            }
            handleArrowClick(menuName)
          }}
          //onClick={() => handleMenuClick(data,hasSubMenu,menuName)}
          //href="/settings"
          to={
            data.link === "/helpdoc" ? location.pathname : hasSubMenu ? '#' : data.link
          }
          style={(
            SSOSettings && 
            SSOSettings.ssoLogin===true && 
            SSOSettings.ssoParameterMappingEnable===true) && 
            data.link ==='/manage-users'?{textDecoration: 'none', width: '100%',pointerEvents: "none",opacity:0.5}:{textDecoration: 'none', width: '100%'}}
  
          className={location.pathname === data.link || location.pathname.startsWith(data.link) ? hasSubMenu ? "active-section" : "active-link" : ""}
          >
            {t(data.label)}
          </Link>
          {hasSubMenu && (
            <Arrow
              onClick={() => handleArrowClick(menuName)}
              toggle={activeMenus.includes(menuName)}
            />
          )}
        </Item>
        {hasSubMenu && (
          <SubMenu
            dept={dept}
            data={data.submenu}
            toggle={activeMenus.includes(menuName)}
            menuIndex={menuIndex}
          />
        )}
      </LI>
    )
  }

  const SubMenu = ({ dept, data, toggle, menuIndex }) => {
    if (!toggle) {
      return null;
    }

    dept = dept + 1;

    return (
      <UL>
        {data.map((menu, index) => {
          const menuName = `sidebar-submenu-${dept}-${menuIndex}-${index}`;

          return (
            <ListMenu
              dept={dept}
              data={menu}
              hasSubMenu={menu.submenu}
              menuName={menuName}
              key={menuName}
              menuIndex={index}
            />
          );
        })}
      </UL>
    );
  };

  return (
    <MainContainer style={{display: "flex", flexDirection: "column"}}>
    <LeftNav>
    <UL>
      {menus.map((menu, index) => {
        const dept = 1;
        const menuName = `sidebar-menu-${dept}-${index}`;
        return (
          <div key={`sidebar ${index}`}>

          {menu?.dividerNeeded ? <Divider key={`sidebar.divider ${index}`} /> : ""}
          <ListMenu
            dept={dept}
            data={menu}
            hasSubMenu={menu.submenu}
            menuName={menuName}
            key={menuName}
            menuIndex={index}
          />
          </div>
        );
      })}
    </UL>
    </LeftNav>
    </MainContainer>
  );
};

export default MultiMenus;
